var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"vuestic-navbar navbar navbar-toggleable-md"},[_c('div',{staticClass:"vuestic-navbar__logo navbar-brand-container align--center justify--start"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/dashboard"}},[_c('img',{attrs:{"src":require('@/assets/images/logo-ddh.png'),"width":"127","alt":""}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }